import { useSelector } from "react-redux";
import { Badge, Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import PageHeader from "../../../components/PageHeader/PageHeader";
import { dashboardLinks } from "../../../utils/data";
import { Col, Row } from "../../../components/Grid/Grid";
import { convertRoleToPath } from "../../../utils";

const ServicesUser = () => {
  const auth = useSelector((state) => state.auth);
  const permissions = useSelector((state) => state.permissions);

  const filterLinks = (menuItems) => {
    return menuItems
      .map((menu) => {
        if (menu.permission && !permissions[menu.permission]) return null;

        if (menu.links) {
          const filteredLink = filterLinks(menu.links);
          menu.links = filteredLink.filter((item) => item !== null);
          return menu.links.length > 0 ? menu : null;
        }

        return menu;
      })
      .filter((menu) => menu !== null);
  };

  return (
    <>
      <SiteTitle title="خدمات" />

      <PageHeader title="خدمات" description="خدماتی که رفاهی تو ارائه میدهد" />

      {filterLinks(dashboardLinks).map((item, index) => (
        <Card key={index}>
          <CardBody>
            <div className="d-flex justify-content-between align-items-center">
              <h5>{item.title}</h5>
              <Link to={item.type} className="fw-bold">
                مشاهده همه
              </Link>
            </div>
            <br />
            <Row className="gy-4">
              {item.links?.map((_item) => (
                <Col size="6" md="4" lg="3" xxl="2">
                  <Card key={_item} className="text-center h-100">
                    <CardBody>
                      <Link
                        to={`/${convertRoleToPath(auth.role)}/${_item?.url}`}
                        className="d-flex flex-column justify-content-between align-items-between"
                      >
                        <img
                          src={`/assets/images/logos/${_item.logo}`}
                          title={_item.title}
                          alt={_item.title}
                          className="img-fluid"
                          {...(!_item.url && {
                            style: {
                              filter: "grayscale(100%)",
                            },
                          })}
                        />
                        <h6 className="mt-2">
                          {_item.title}{" "}
                          {!_item.url && (
                            <Badge
                              style={{
                                position: "absolute",
                                right: 10,
                                top: 10,
                              }}
                              color="primary"
                            >
                              به زودی
                            </Badge>
                          )}
                        </h6>
                      </Link>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
          </CardBody>
        </Card>
      ))}
    </>
  );
};

export default ServicesUser;
